module.exports = __webpack_public_path__ + "img/logo.3906680d.svg";